import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9]Z[A-Z0-9]$/;

export const normalizeGstin = (v) => (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export const isValidGstin = (v) => GSTIN_REGEX.test(normalizeGstin(v));

/** Fetch party details for a GSTIN. Returns backend payload:
 * { found, source, name, address, city, state, state_code, pincode, status, ... } */
export async function lookupGstin(gstin) {
  const r = await axios.get(`${API}/gstin-lookup/${normalizeGstin(gstin)}`);
  return r.data;
}
